module.exports = __webpack_public_path__ + "img/topup_details_failed.d8a873a3.svg";